import { USER_TYPE_CREATOR } from '../../../constants';
import { getUserType } from '../../../util/data';

const draftId = '00000000-0000-0000-0000-000000000000';

const listingAuthorId = listing =>
  listing?.author?.id?.uuid || listing?.relationships?.author?.data?.id?.uuid;

export const getListingEmptyCardData = ({
  currentUser,
  listings,
  listingType,
  icon,
  intl,
  defaultTitleId,
  defaultTextId,
}) => {
  if (getUserType(currentUser) !== USER_TYPE_CREATOR) {
    return null;
  }

  const currentUserId = currentUser?.id?.uuid;
  const hasLoadedListingOfType =
    !!currentUserId &&
    listings?.some(
      listing =>
        listing?.attributes?.publicData?.listingType === listingType &&
        listingAuthorId(listing) === currentUserId
    );

  return {
    icon,
    title: intl.formatMessage({ id: defaultTitleId }),
    text: hasLoadedListingOfType
      ? intl.formatMessage({ id: defaultTextId })
      : intl.formatMessage({ id: 'ListingEmptyCard.addFirstListing' }, { listingType }),
    linkprops: {
      name: 'EditListingPage',
      params: { slug: 'draft', id: draftId, type: 'new', tab: 'details' },
      to: { search: `?listingType=${listingType}` },
    },
  };
};
